import i18next from 'i18next';

i18next.addResources('es', 'Error', {
  default: 'Ocurrió un error'
});
